import { Routes } from '@angular/router';
import { AuthLayout } from '../layouts/auth-layout/auth-layout';
import { Login } from '../features/login/login';
import { TwoFactorAuth } from '../features/two-factor-auth/two-factor-auth';
import { guestGuard } from '../core/guards/auth.guard';

export const AUTH_ROUTES: Routes = [
    {
        path: 'auth',
        component: AuthLayout,
        canActivate: [guestGuard],
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            { path: 'login', component: Login },
            { path: '2fa', component: TwoFactorAuth },
            { 
                path: 'forgot-password', 
                loadComponent: () => import('../features/forgot-password/forgot-password').then(m => m.ForgotPassword) 
            },
        ]
    }
];
